<template>
	<div class="detaill margin-left">
		<div class="flex bg-white list-item margin-bottom-sm">
			<img class="cover margin-right-sm" :src="logo" >
			<div class="text-left flex flex-sub flex-direction justify-between">
				<div class="titlw">{{title}}</div>
				<p class="text-sm text-666">课程章节：共{{chapter.length}}节</p>
				<div class="flex align-center justify-between">
					<p class="text-price priced text-bold text-prices">{{pay_price}}</p>
					<div class="flex align-center">
						<p class="text-center text-sm text-ccc upbtn pointer" @click="add" v-if="is_resources == 0">上传章节</p>
						<p class="text-center text-sm text-ccc paybtn pointer" @click="edia" v-if="is_resources == 0||is_resources == 3">重新发布</p>
					</div>
				</div>
			</div>
			<div v-if="is_resources == 1" class="status paied">已驳回</div>
			<div v-if="is_resources == 2" class="status paied">已通过</div>
			<div v-if="is_resources == 0" class="status paied">待审核</div>
			<div v-if="is_resources == 3" class="status paied">待提交</div>
		</div>
		<div class="bg-white deinfo">
			<div class="flex align-center info-title">
				<p class="pointer" @click="infoindex = 0" :class="infoindex == 0?'text-theme actve':''">课程介绍</p>
				<p class="pointer" @click="infoindex = 1" :class="infoindex == 1?'text-theme actve':''">课程目录</p>
			</div>
			<div class="padding-lg" v-if="infoindex == 0">
				<div v-html="content"></div>
			</div>
			<div class="padding" v-if="infoindex == 1">
				<div class="flex align-center margin-bottom-sm" v-for="(item,index) in chapter" :key="index">
					<img v-if="type == 0" class="broadcast margin-right-xs" src="../../../assets/img/broadcast.png" >
					<img v-if="type == 1" class="broadcast margin-right-xs " src="https://wz89.lzym.top/web/static/skill/lock.png" >
					<!-- <p class="audition text-white margin-right-xs">试听</p> -->
					<p>{{item.chapter_title}}</p>
				</div>
			</div>
			<div class="padding-lg" v-if="is_resources == 1">
				<p class="text-left bohui">驳回原因</p>
				<p class="text-df text-left margin-top text-prices">课程介绍不清晰，设置价格太高，没有在价格范围内容，请将课程价格设置在200~500之间。</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				infoindex:1,//课程介绍   课程目录
				id:'',//课程id
				logo:'',//课程封面
				pay_price:'',//价格
				title:'',//标题
				type:'',//类型
				chapter:[],
				content:'',
				is_resources:0
			};
		},
		created() {
			Bus.$on('getdid',data=>{
				this.id = data
				this.getdetail()
			})
			Bus.$on('addChatper',data=>{
				this.infoindex = 1
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('getdid')
		},
		methods: {
			/**
			 * 详情
			 * */
			getdetail(){
				this.ajax('get', '/api/pc/courseapply/getApplyInfo',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.title = res.data.course.title
						this.type = res.data.course.type
						this.pay_price = res.data.course.price
						this.chapter = res.data.chapter
						this.content = res.data.course.content
						this.is_resources = res.data.course.is_resources
						this.logo = res.data.course.logo
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 编辑
			 * */
			edia(){
				let typeq = {
					type:'curlease',
					typeone:''
				}
				this.$emit('gettype',typeq)
				setTimeout(()=>{
					let inf ={
						id:this.id,
						isedit:1
					}
					Bus.$emit('getdexatail',inf)
				},500)
			},
			//添加章节
			add(){
				let info = {
					id:this.id,
					type:this.type
				}
				this.$emit('addcha')
				setTimeout(()=>{
					Bus.$emit('release',info)
				},500)
			}
		}
	}
</script>

<style scoped lang="less">
	.detaill{
		width: 921px;
	}
	.bohui{
		font-size: 26px;
	}
	.list-item{
		padding: 30px;
		border-radius: 20px;
		width: 921px;
		position: relative;
		.status{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.paied{
			background: rgba(11,131,124,0.1000);
			color: #0B837C;
		}
		.upbtn{
			width: 153px;
			height: 45px;
			line-height: 45px;
			color: #fff;
			background: #0B837C;
			border-radius: 23px;
			margin-right: 15px;
		}
		.paybtn{
			width: 193px;
			height: 45px;
			line-height: 45px;
			color: #fff;
			background: #0B837C;
			border-radius: 23px;
		}
		.priced{
			font-size: 34px;
		}
	}
	.cover{
		width: 104px;
		height: 133px;
	}
	.titlw{
		font-size: 26px;
	}
	.broadcast{
		width: 26px;
		height: 26px;
	}
	.audition{
		width: 44px;
		height: 24px;
		line-height: 24px;
		background: #0B837C;
		border-radius: 6px;
	}
	.actve{
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			content: '';
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
		}
	}
	.info-title{
		width: 920px;
		height: 69px;
		background: #F7F6F6;
		border-radius: 20px 20px 0px 0px;
		p{
			width: 120px;
			height: 69px;
			line-height: 69px;
		}
	}
	.deinfo{
		box-shadow: 2px 3px 29px 1px rgba(201,199,199,0.3000);
		border-radius: 20px;
		min-height: 650px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/course/exa-detail.vue